import rmskincareAPI from '../utils/rmskincareAPI'

const storageApi = {
  //Purchase Record
  getOrFilterPurchasesRecord: async (query) =>{
    const result = await rmskincareAPI.get(
      `/management/product/record/find${query}`
    )
    return result.data.data
  },

  //Inventory Record
  getOrFilterInventoryRecord: async (query)=>{
    const result = await rmskincareAPI.get(
      `/management/product/storage/find${query}`
  )
  return result.data.data
  },

  //add 
  addInventoryRecord : async(requestBody)=>{
    const result=await rmskincareAPI.post(
      `/management/product/storage/addList` ,requestBody
    )
    return result.data.data

  },

  //update

  updateInventoryRecord: async (requestBody)=>{
    const result =await rmskincareAPI.post(
      `/management/product/storage/update` , requestBody
    )
    return result.data.data
  },

  //delete
  deleteInventoryRecord: async (InventoryProductId)=>{
    let requestBody=[InventoryProductId]
    const result =await rmskincareAPI.post(
      `/management/product/storage/del` , requestBody
    ) 
    return result
  },

  //Stock
  getOrFilterProductStockRecord: async (query)=> {
    const result =await rmskincareAPI.get(
      `/management/product/store/find${query}`
    )
    return result.data.data
  },
 
  updateProductStock : async(requestBody)=>{
    const result =await rmskincareAPI.post(
    `/management/product/store/update`,requestBody
    )
    return result.data.data
  },

  //Low Stock Alert
  getProductLowStockList: async(query)=>{
    const result = await rmskincareAPI.get(
      `/management/product/store/alarm${query}`
    )
    return result.data.data
  },

  //Lightweight count of low-stock products, used for a login-time alert badge
  getLowStockCount: async (storeId) => {
    const query = storeId ? `?storeId=${storeId}` : ''
    const result = await rmskincareAPI.get(
      `/management/product/store/alarm/count${query}`
    )
    return result.data.data
  },

  //Current stock for a single product/store (used to validate consumption before submit)
  getProductStock: async (productId, storeId) => {
    const result = await rmskincareAPI.get(
      `/management/product/store/stock?productId=${productId}&storeId=${storeId}`
    )
    return result.data.data
  },

  //Change history (ledger) for a single product/store, used to trace stock discrepancies
  getProductStockLedger: async (query) => {
    const result = await rmskincareAPI.get(
      `/management/product/store/ledger${query}`
    )
    return result.data.data
  },

}

export default storageApi
